import { getLogger } from '../logger';

const SEPARATOR_VERSION = '.';

const debug = getLogger('services:template:VersionTemplate');

export class VersionTemplate {
  /**
   * Build a VersionTemplate Object
   * */
  constructor(stringVersion) {
    this.versionArray = VersionTemplate._transformStringToArray(stringVersion);
  }

  /**
   * Get the first version digit
   * */
  getFirtDigit() {
    return this.versionArray[0];
  }

  /**
   * Get the second version digit
   * */
  getSecondDigit() {
    return this.versionArray[1];
  }

  /**
   * Get the third version digit
   * */
  getThirdDigit() {
    return this.versionArray[2];
  }

  /**
   * Return true if the version is compatible. Use the first digit.
   * For example : 1.x.x is compatible with 1.0.0, 1.0.1, 1.1.1, etc
   * */
  isCompatible(version) {
    return this.getFirtDigit() === version.getFirtDigit() && this.getSecondDigit() === version.getSecondDigit();
  }

  /**
   * Verify if the version is valid
   * */
  static _isValid(versionArray) {
    return versionArray.length === 3;
  }

  /**
   * Transform a string in a array
   * */
  static _transformStringToArray(stringVersion) {
    let result = [];
    if (!stringVersion) {
      debug.error('error creating Version object - no version');
    } else {
      let versionArray = stringVersion.split(SEPARATOR_VERSION);
      if (VersionTemplate._isValid(versionArray)) {
        result = versionArray;
      } else {
        debug.error(`error creating Version object %O`, versionArray);
      }
    }

    return result;
  }
}
